export const BODY_OVERFLOW_SHIFT_EVENT = 'body_overflow_shift';
